import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';

interface UnassignedBudgetCellProps {
  totalBudget: number;
  unassignedBudget: number;
}

export const UnassignedBudgetCell: React.FC<UnassignedBudgetCellProps> = ({ totalBudget, unassignedBudget }) => {
  const percentage = totalBudget > 0 ? (unassignedBudget / totalBudget) * 100 : 0;

  let color = 'default';
  if (percentage > 50) {
    color = '#EA9999';
  } else if (percentage > 25) {
    color = '#F9CB9C';
  } else if (percentage > 0) {
    color = '#FFD965';
  }

  if (percentage === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Tooltip title={`${percentage.toFixed(0)}% of the total budget is unallocated to any division!`} arrow={false} placement='right'>
        <Chip
          label={`${percentage.toFixed(0)}%`}
          size='small'
          sx={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            '& .MuiChip-label': {
              fontWeight: 500,
              fontSize: '1 rem',
              padding: 0,
            },
            backgroundColor: color,
          }}
        />
      </Tooltip>
    </Box>
  );
};
